export function bannerDay(iso?: string | null): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString([], { month: "short", day: "numeric" });
}

export function bannerDate(iso?: string | null): string {
  const date = bannerDay(iso);
  if (!date) return "";
  const time = new Date(iso as string).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  return `${date}, ${time}`;
}
